import { render, staticRenderFns } from "./NoteDetail.vue?vue&type=template&id=72b9b8fb&scoped=true&"
import script from "./NoteDetail.vue?vue&type=script&lang=js&"
export * from "./NoteDetail.vue?vue&type=script&lang=js&"
import style0 from "./NoteDetail.vue?vue&type=style&index=0&id=72b9b8fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b9b8fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72b9b8fb')) {
      api.createRecord('72b9b8fb', component.options)
    } else {
      api.reload('72b9b8fb', component.options)
    }
    module.hot.accept("./NoteDetail.vue?vue&type=template&id=72b9b8fb&scoped=true&", function () {
      api.rerender('72b9b8fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/MeetingNote/Detail/NoteDetail.vue"
export default component.exports